module.exports = __webpack_public_path__ + "1d9b414304abec4a18a53bf46b6b6c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_recency.png
// module id = 58
// module chunks = 0 1 2 3 4